/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 14/01/2014
 * Time: 13:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('SupplierView',["$filter","Supplier","SupplierData","SupplierSrv","Format","PhoneFormat",
        function ($filter,Supplier,SupplierData,SupplierSrv,Format,PhoneFormat)
        {

        var  SupplierView = function(supplier,sIndex,domainView)
        {
            this.sIndex = sIndex;
            this.domainView = domainView;
            this.label = null;
            this.lastName = null;
            this.firstName = null;
            this.phone = null;
            this.landline = null;
            this.email = null;
            this.login = null;
            this.address1 = null;
            this.address2 = null;
            this.city = null;
            this.postCode = null;
            this.productsView= [];
            this.loadDataFrom(supplier);
        };
        SupplierView.prototype.getModel = function()
        {
            if (this.sIndex!=-1)
                return SupplierData.getByIndex(this.sIndex);
            return null;
        }
        SupplierView.prototype.loadDataFrom = function(supplier)
        {
            if (supplier !==undefined && supplier)
            {
                this.label = supplier.label;
                this.lastName = supplier.lastName;
                this.firstName = supplier.firstName;
                this.phone = PhoneFormat.formatNumberWithoutCountry(supplier.phone);
                this.landline = PhoneFormat.formatNumberWithoutCountry(supplier.landline);
                this.email = supplier.email;
                this.isVerified = supplier.isVerified;
                this.address1 = supplier.address1;
                this.address2 = supplier.address2;
                this.city = supplier.city;
                this.postCode = supplier.postCode;
            }
        }
        SupplierView.prototype.copyDataTo = function(supplier)//
        {
            supplier.label = this.label  ;
            supplier.lastName = this.lastName  ;
            supplier.firstName = this.firstName;
            if(this.phone != null)
               supplier.phone = this.phone.replace(/\s/g, '');
            else
                supplier.phone = null;
            if(this.landline != null)
                supplier.landline = this.landline.replace(/\s/g, '');
            else
                supplier.landline = null;
            supplier.email = this.email;
            supplier.isVerified = this.isVerified;
            supplier.address1 = this.address1;
            supplier.address2 = this.address2;
            supplier.city = this.city;
            supplier.postCode = this.postCode;


        }
        SupplierView.prototype.addProductView = function(productView)//
        {
            if (productView)
            {
                var index =  this.productsView.indexOf(productView);
                if (index==-1)
                {
                    this.productsView.push(productView);
                }
            }
        }
        SupplierView.prototype.removeProductView = function(productView)//
        {
            var index =  this.productsView.indexOf(productView);
            if (index!=-1)
            {
                this.productsView.splice(index,1);
            }
        }
        SupplierView.prototype.isChanged = function()
        {
            var supplier = this.getModel();
            if (supplier)
                return (
                    this.label != supplier.label ||
                        this.firstName != supplier.firstName ||
                        this.lastName != supplier.lastName ||
                        this.phone != Format.formatNumber(supplier.phone) ||
                        this.landline != Format.formatNumber(supplier.landline) ||
                        this.email != supplier.email
                    );
            else
                return true;

        }
        SupplierView.prototype.removeModel = function()
        {
            var supplier = this.getModel();
            if (supplier!=null)
                SupplierSrv.remove(supplier);
        }
        SupplierView.prototype.reloadModel = function()
        {
            var supplier = this.getModel();
            if (supplier!=null)
                this.loadDataFrom(supplier);

        }
        SupplierView.prototype.updateModel = function(save,endFunction)
        {
            //Save by default
            var supplier = this.getModel();
            if (!supplier)//create it
            {
                supplier = new Supplier();
                this.sIndex = SupplierData.getIndexOf(supplier);
            }

            this.copyDataTo(supplier);
            if (save===undefined||save)//Save by default
                SupplierSrv.save(supplier,endFunction);
        }
        SupplierView.prototype.restoreModel = function()
        {
            var supplier = this.getModel();
            if (supplier)
                SupplierSrv.restore(supplier);
        }
        SupplierView.prototype.canSave = function()
        {
            return (this.label != null && this.label != "");
        }
        //FIX ME : DUPLICATED FUNCTION
        SupplierView.prototype.hasValidCellPhone = function(isMandatory)
        {
            // if supplier has a valid cellphone number
            if(!isMandatory) {
                // if not mandatory, phone number is not an obligation
                if (this.phone == null || this.phone=="")
                    return true;
            }
            if (this.phone && this.phone.length > 0) {
                if (this.phone[0] == 0 && this.phone.replace(/[^0-9]/g, '').length == 10 &&
                    this.phone.length == 14 &&
                    (this.phone[1] == 6 || this.phone[1] == 7)) {
                    // if length with only numbers equals 10 and if the first two numbers are 06 or 07
                    // french number
                    return true;
                }
                if (this.phone[0] == '+') {
                    // international number
                    return true;
                }
            }

            return false;
        }
        SupplierView.prototype.hasValidLandLine = function()
        {
            // if site has a valid work phone number
            if(this.landline == null || this.landline == "")
                return true;
            if (this.landline && this.landline.length > 0) {
                if (this.landline[0] == 0 && this.landline.replace(/[^0-9]/g, '').length == 10 && this.landline.length == 14) {
                    // if length with only numbers equals 10 and if the first number is 0
                    // french number
                    return true;
                }
                if (this.landline[0] == '+') {
                    // international number
                    return true;
                }
            }

            return false;
        }
        return  SupplierView;
    }]);




// WEBPACK FOOTER //
// ./js/services/views/SupplierView.js